import { createSlice } from '@reduxjs/toolkit';
import { defaultAuctionsNearMeSlice } from '@/redux/modules/auctionsNearMe/auctionsNearMe.types';
import { fetchCatalogsNearMeByBounds, fetchCatalogsNearMeByCityAndState } from './auctionsNearMe.actions';

const auctionsNearMeSlice = createSlice({
    extraReducers: (builder) => {
        // Handle fetchCatalogsNearMeByBounds lifecycle
        builder.addCase(fetchCatalogsNearMeByBounds.pending, (slice) => {
            slice.loading = true;
            slice.error = null;
        });
        builder.addCase(fetchCatalogsNearMeByBounds.fulfilled, (slice, { payload }) => {
            slice.loading = false;
            slice.error = null;
            if (!payload.error && payload.payload) {
                slice.catalogIds = payload.payload.catalogIds;
                slice.catalogsNearMe = payload.payload.catalogsNearMe;
                slice.otherPlaces = payload.payload.otherPlaces;
                slice.currentPage = payload.payload.currentPage;
                slice.totalPages = payload.payload.totalPages;
                slice.totalRecords = payload.payload.totalRecords;
            }
        });
        builder.addCase(fetchCatalogsNearMeByBounds.rejected, (slice, action) => {
            slice.loading = false;
            slice.error = action.error.message || 'Failed to fetch catalogs by bounds';
        });

        // Handle fetchCatalogsNearMeByCityAndState lifecycle
        builder.addCase(fetchCatalogsNearMeByCityAndState.pending, (slice) => {
            slice.loading = true;
            slice.error = null;
        });
        builder.addCase(fetchCatalogsNearMeByCityAndState.fulfilled, (slice, { payload }) => {
            slice.loading = false;
            slice.error = null;
            if (!payload.error && payload.payload) {
                slice.catalogIds = payload.payload.catalogIds;
                slice.catalogsNearMe = payload.payload.catalogsNearMe;
                slice.otherPlaces = payload.payload.otherPlaces;
                slice.currentPage = payload.payload.currentPage;
                slice.totalPages = payload.payload.totalPages;
                slice.totalRecords = payload.payload.totalRecords;
            }
        });
        builder.addCase(fetchCatalogsNearMeByCityAndState.rejected, (slice, action) => {
            slice.loading = false;
            slice.error = action.error.message || 'Failed to fetch catalogs by city/state';
        });
    },
    initialState: defaultAuctionsNearMeSlice,
    name: 'auctionsNearMe',
    reducers: {
        clearCatalogsNearMe: (slice) => {
            slice.catalogIds = [];
            slice.catalogsNearMe = [];
            slice.otherPlaces = [];
            slice.currentPage = 0;
            slice.totalPages = 0;
            slice.totalRecords = 0;
            slice.loading = false;
            slice.error = null;
        },
    },
});

export const { reducer: auctionsNearMeReducer } = auctionsNearMeSlice;

export const { clearCatalogsNearMe } = auctionsNearMeSlice.actions;
